import Vue from 'vue'

export default {
  methods: {
    async fetch(query_array, type, only_first) {
      let result

      await Promise.all(query_array)
        .then(res => {
          if (type) {
            result = res.map(el => only_first ? el.data[type][0] : el.data[type])
          } else {
            result = res
          }
        })
        .catch(er => Vue.prototype.$log_error(er))
      return result
    },
  }
}
